"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilterBooleanCell = exports.DisabledFilterBooleanCell = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const clsx_1 = __importDefault(require("clsx"));
const select_1 = require("../../select/select");
const list_source_hook_1 = require("../../../utils/list-source-hook");
const field_filter_styles_1 = require("../field-filter-styles");
function DisabledFilterBooleanCell(props) {
    return react_1.default.createElement(FilterBooleanCell, { ...props, disabled: true });
}
exports.DisabledFilterBooleanCell = DisabledFilterBooleanCell;
function FilterBooleanCell({ disabled, value, onChange, }) {
    const intl = (0, react_intl_1.useIntl)();
    const classes = (0, field_filter_styles_1.useFilterStyles)();
    const source = (0, list_source_hook_1.useStaticListSource)([
        {
            id: 'true',
            name: intl.formatMessage({
                id: 'EAS_FIELD_FILTER_CELL_BOOLEAN_OPTION_SELECTED',
                defaultMessage: 'Vybrané',
            }),
        },
        {
            id: 'false',
            name: intl.formatMessage({
                id: 'EAS_FIELD_FILTER_CELL_BOOLEAN_OPTION_NOT_SELECTED',
                defaultMessage: 'Nevybrané',
            }),
        },
    ]);
    return (react_1.default.createElement("div", { className: (0, clsx_1.default)(classes.textWithoutSelectWrapper, {
            [classes.disabled]: disabled,
        }) },
        react_1.default.createElement(select_1.Select, { source: source, value: value, onChange: onChange, disabled: disabled, valueIsId: true })));
}
exports.FilterBooleanCell = FilterBooleanCell;
//# sourceMappingURL=filter-boolean-cell.js.map